module.exports = __webpack_public_path__ + "img/cover3.8f499100.png";